<div dw-row class="forget-bg">
  <div dw-col class="forget-content">
    <div dw-row class="forget-main-block">
      <div dw-col [dwXs]="'8'" [dwSm]="'8'" [dwMd]="'9'" [dwLg]="'9'">
      </div>
      <div dw-col [dwXs]="'8'" [dwSm]="'8'" [dwMd]="'6'" [dwLg]="'6'">
        <img class="forget-logo" src="{{dwLogoPath}}">
        <dw-forget-block [verificationType]="verificationType"></dw-forget-block>
      </div>
      <div dw-col [dwXs]="'8'" [dwSm]="'8'" [dwMd]="'9'" [dwLg]="'9'">
      </div>
    </div>
    <div dw-row class="forget-copyright-block">
      <div dw-col class="forget-copyright">
        <span>© Data Systems Consulting Co., Ltd. All rights reserved.</span>
      </div>
    </div>
  </div>
</div>
